import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import isEqual from "lodash/isEqual";
import { useMapStore } from "stores/map";

import { RootState } from "../../../store/rootReducer";

export function useFacilityGroupBy() {
  const setFacilityConfirmationChoice = useMapStore(
    (s) => s.setFacilityConfirmationChoice
  );
  const setFacilityOverrideSizeLimit = useMapStore((s) => s.setFacilityOverrideSizeLimit);
  const facilityGroupBy = useSelector(
    (state: RootState) => state.groupBy.globalFacilityFocus
  );

  const prevFacilityGroupByRef = useRef(facilityGroupBy);

  useEffect(() => {
    const currentFacilityGroupBy = facilityGroupBy;
    const previousFacilityGroupBy = prevFacilityGroupByRef.current;

    if (
      !isEqual(currentFacilityGroupBy, previousFacilityGroupBy) &&
      previousFacilityGroupBy !== undefined
    ) {
      setFacilityConfirmationChoice(null);
      setFacilityOverrideSizeLimit(false);
    }

    prevFacilityGroupByRef.current = currentFacilityGroupBy;
  }, [facilityGroupBy, setFacilityConfirmationChoice, setFacilityOverrideSizeLimit]);
  return facilityGroupBy;
}
